export const replacePlaceholders = (text: string, placeholders: Record<string, string | undefined>) => {
  const textPlaceholders = text.match(/\{[^}]+\}/g) || []
  const missingPlaceholder = textPlaceholders.find(key => !placeholders[key.slice(1, -1)])
  if (missingPlaceholder) {
    return ''
  }
  return Object.keys(placeholders).reduce(
    (result, key) => result.replaceAll(`{${key}}`, placeholders[key] ?? ''),
    text
  )
}